/** Matches controlled_substances/constants ControlledSubstanceStatus */
export const ControlledSubstanceStatus = {
  Controlled: "CONTROLLED",
  DrugOfConcern: "DRUG_OF_CONCERN",
  NotApplicable: "NOT_APPLICABLE",
} as const;
export type ControlledSubstanceStatus =
  (typeof ControlledSubstanceStatus)[keyof typeof ControlledSubstanceStatus];

/** Matches controlled_substances/constants ControlledSubstanceComplianceFailureKind */
export const ControlledSubstanceComplianceFailureKind = {
  MissingClientFields: "MISSING_CLIENT_FIELDS",
  MissingPatientFields: "MISSING_PATIENT_FIELDS",
  MissingPrescriber: "MISSING_PRESCRIBER",
  PrescriberDea: "PRESCRIBER_DEA",
  SupplyExceedsControlledLimit: "SUPPLY_EXCEEDS_CONTROLLED_LIMIT",
  RefillsExceedControlledLimit: "REFILLS_EXCEED_CONTROLLED_LIMIT",
  ExpiryExceedsControlledLimit: "EXPIRY_EXCEEDS_CONTROLLED_LIMIT",
  DispensingBlocked: "DISPENSING_BLOCKED",
  ClientUnderAge: "CLIENT_UNDER_AGE",
} as const;
export type ControlledSubstanceComplianceFailureKind =
  (typeof ControlledSubstanceComplianceFailureKind)[keyof typeof ControlledSubstanceComplianceFailureKind];

/** Matches controlled_substances/types ClientProfileField */
export type ControlledSubstanceClientProfileField =
  | "first_name"
  | "last_name"
  | "primary_contact_number"
  | "date_of_birth"
  | "drivers_license_number"
  | "drivers_license_state";

/** Matches controlled_substances/types PatientField */
export type ControlledSubstancePatientField = "name" | "species" | "birth_date";

/** Matches controlled_substances/types PrescriptionField */
export type ControlledSubstancePrescriptionField =
  | "prescribed_by"
  | "days_supply"
  | "refills"
  | "expiration_date";

/** Matches controlled_substances/types DestinationField */
export type ControlledSubstanceDestinationField = "shipping_address";

/** Matches controlled_substances/types ComplianceFailureField */
export type ControlledSubstanceComplianceFailureField =
  | ControlledSubstanceClientProfileField
  | ControlledSubstancePatientField
  | ControlledSubstancePrescriptionField
  | ControlledSubstanceDestinationField;

/** Matches controlled_substances ClinicControlledSubstancePolicyItemFailureSerializer */
export type ControlledSubstanceFailure = {
  kind: ControlledSubstanceComplianceFailureKind;
  /** The offending fields as their API names; each editor maps these to its own form keys */
  fields: ControlledSubstanceComplianceFailureField[];
  detail: string;
};
